import React, { useState } from 'react';
import { authAxios } from '@/lib/api';

const INPUT_CLS = 'border border-earth/15 rounded-md px-3 py-2 text-sm font-sans focus:outline-none focus:ring-2 focus:ring-saffron/30 bg-cream/30';
const LABEL_CLS = 'text-[10px] uppercase tracking-wider text-earth/50 font-sans font-semibold mb-1 block';

export default function ChangePasswordPanel({ onDone }) {
  const [currentPwd, setCurrentPwd] = useState('');
  const [newPwd, setNewPwd] = useState('');
  const [msg, setMsg] = useState('');

  const submit = async () => {
    setMsg('');
    try {
      await authAxios.post('/api/auth/change-password', { current_password: currentPwd, new_password: newPwd });
      setMsg('Password changed successfully!');
      setCurrentPwd(''); setNewPwd('');
      setTimeout(onDone, 2000);
    } catch (e) {
      setMsg(e.response?.data?.detail || 'Failed to change password');
    }
  };

  return (
    <div className="bg-white rounded-lg border border-saffron-100/50 shadow-card-lift p-5 mb-6" data-testid="change-pwd-panel">
      <h3 className="font-display text-base font-bold text-earth-dark mb-3">Change Password</h3>
      {msg && <p className={`text-sm font-sans mb-3 ${msg.includes('success') ? 'text-green-600' : 'text-chilli'}`} data-testid="change-pwd-msg">{msg}</p>}
      <div className="flex gap-3 items-end">
        <div>
          <label className={LABEL_CLS}>Current Password</label>
          <input type="password" value={currentPwd} onChange={e => setCurrentPwd(e.target.value)} className={INPUT_CLS} data-testid="current-pwd" />
        </div>
        <div>
          <label className={LABEL_CLS}>New Password</label>
          <input type="password" value={newPwd} onChange={e => setNewPwd(e.target.value)} className={INPUT_CLS} data-testid="new-pwd" />
        </div>
        <button onClick={submit} disabled={!currentPwd || !newPwd} className="bg-saffron text-white font-sans font-semibold text-xs px-5 py-2.5 rounded-md hover:bg-saffron-dark transition-colors disabled:opacity-40" data-testid="change-pwd-submit">
          Update
        </button>
      </div>
    </div>
  );
}
